import React from "react";
import { addPossessive } from "@brz-shared/add.possesive"
import { usePartner } from "@brz-utils/contexts/partner.context";


export const RichCompanyName = (props: any) => {
    const { partner } = usePartner();

    return partner?.displayName || props.fallback ? (<span>
        { props.usePossesive ? addPossessive(partner?.displayName || props.fallback) : partner?.displayName || props.fallback }
        {/* {!partner?.displayName ? <br/> : null} */}
    </span>) : <></>
}